import { useEffect, useMemo } from "react";
import Head from "next/head";
import Header from "./header.js";
import { initGA } from "../Analytics/google-analytics";
import { OrganizationSchema, HomeFaqSchema } from "../schema";
import { useRouter } from "next/router";

export default (props) => {
  const {
    title,
    children,
    showBackground,
    middleElement,
    showNavLinks,
    forceMobileBackground,
    invertLogo,
    showAvatar = false,
    bottomCta,
    bankBottomCta,
    description,
    mainBannerText,
    showEllisBanner,
    showReferralBanner,
    isLoggedIn = false,
  } = props;
  const router = useRouter();
  const cleanPath = useMemo(
    () => `https://leapfinance.com${router.asPath?.split("?")?.[0]}`,
    [router.asPath]
  );

  const getMarginTopClass = (showReferralBanner, showEllisBanner) => {
    if (showReferralBanner && showEllisBanner)
      return "mt-[230px] md:mt-[180px]";
    if (showEllisBanner) return "mt-[150px] md:mt-[120px]";
    if (showReferralBanner) return "mt-[120px]";
    return "mt-[65px]";
  };

  useEffect(() => {
    initGA();
  }, []);

  return (
    <div className="font-sans w-screen md:min-h-screen h-full antialiased mx-auto relative">
      <Head>
        <title>{`${title} | Leap Finance`}</title>
        {description && (
          <>
            <meta name="description" content={description} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@LeapFinanceIn" />
            <meta
              content={`${title} | Leap Finance`}
              property="twitter:title"
            />
            <meta property="og:url" content={cleanPath} />
            <meta property="og:title" content={`${title} | Leap Finance`} />
            <meta property="og:description" content={description} />
            <meta
              property="og:image"
              content="http://cdn.mcauto-images-production.sendgrid.net/34a5d9ee598a3b60/90aa2b54-ae81-474f-88a1-c6daa7dbc5b5/192x192.png"
            />
            <meta property="og:type" content="website" />
            <meta property="fb:app_id" content="101199618003786" />
            <meta
              content="width=device-width, initial-scale=1"
              name="viewport"
            />
          </>
        )}
        <link rel="canonical" href={cleanPath} />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/static/apple-touch-icon.png"
        />
        <link rel="manifest" href="/static/site.webmanifest"></link>
        <link
          href="https://d3qj1pefcqovqy.cloudfront.net/61a5bb0516b045285e37ec59_logo_leap_1_2_8731b923b7.png"
          rel="shortcut icon"
          type="image/x-icon"
        />
        {(router.pathname === "/" || router.pathname === "/about") && (
          <OrganizationSchema />
        )}
        {router.pathname === "/" && <HomeFaqSchema />}
      </Head>
      <Header
        showBackground={showBackground}
        middleElement={middleElement}
        showNavLinks={showNavLinks}
        forceMobileBackground={forceMobileBackground}
        invertLogo={invertLogo}
        showAvatar={showAvatar}
        bottomCta={bottomCta}
        bankBottomCta={bankBottomCta}
        isLoggedIn={isLoggedIn}
        mainBannerText={mainBannerText}
        showEllisBanner={showEllisBanner}
        showReferralBanner={showReferralBanner}
      />

      <main className={getMarginTopClass(showReferralBanner, showEllisBanner)}>
        {children(isLoggedIn)}
      </main>
    </div>
  );
};
